export default {
    title: 'Nutzer',
    email: 'E-Mail',
    customName: 'Anzeigename',
    firstname: 'Vorname',
    lastname: 'Nachname',
    role: 'Rolle',
    roles: 'Rollen',
    role_name: 'Rolle',
    created_at: 'Erstellt am',
    id: 'ID',
    impersonate: 'Support geben',
    likeUser: 'Like geben',
    organisationName: 'Lieferantenname',
    organisation: 'Lieferant',
    customFilterOrganisationName: 'Lieferant (Name)',

    qf_onlyEmployees: 'Nur Mitarbeiter'
}